import { TrendingUp, TrendingDown, Equal } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface PriceChangeProps {
  oldPrice: number;
  newPrice: number;
  oldTimeLabel: string;
  newTimeLabel: string;
  oldPriceList?: string;
  newPriceList?: string;
}

export default function PriceChangeIndicator({ oldPrice, newPrice, oldTimeLabel, newTimeLabel, oldPriceList, newPriceList }: PriceChangeProps) {
  const diff = newPrice - oldPrice;
  const isMore = diff > 0;
  const isLess = diff < 0;
  const isSame = diff === 0;

  return (
    <div className="rounded-lg border p-3 space-y-2">
      {!isSame && (
        <div className={`flex items-center gap-2 text-sm font-medium ${isMore ? "text-destructive" : "text-green-600"}`}>
          {isMore ? <TrendingUp className="h-4 w-4" /> : <TrendingDown className="h-4 w-4" />}
          <span>Priset {isMore ? "ökar" : "minskar"} med {Math.abs(diff)} kr</span>
        </div>
      )}
      {isSame && (
        <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
          <Equal className="h-4 w-4" />
          <span>Samma pris</span>
        </div>
      )}

      <div className="grid grid-cols-2 gap-3 text-xs">
        <div className="space-y-0.5">
          <p className="text-muted-foreground">Nuvarande tid</p>
          <p className="font-medium">{oldTimeLabel}</p>
          {oldPriceList && oldPriceList !== "standard" && (
            <Badge variant="outline" className="text-[10px]">{oldPriceList}</Badge>
          )}
          <p className="font-bold">{oldPrice} kr</p>
        </div>
        <div className="space-y-0.5">
          <p className="text-muted-foreground">Ny tid</p>
          <p className="font-medium">{newTimeLabel}</p>
          {newPriceList && newPriceList !== "standard" && (
            <Badge variant="outline" className="text-[10px]">{newPriceList}</Badge>
          )}
          <p className="font-bold">{newPrice} kr</p>
        </div>
      </div>

      {isMore && (
        <p className="text-xs text-destructive">
          Mellanskillnaden {Math.abs(diff)} kr debiteras vid bekräftelse.
        </p>
      )}
      {isLess && (
        <p className="text-xs text-green-600">
          {Math.abs(diff)} kr krediteras till ditt konto.
        </p>
      )}
    </div>
  );
}
